module.exports = __webpack_public_path__ + "static/media/facebook-messenger.5f1859c0.svg";